<template>
  <div class="datamain">
    <Header />
    <div class="datamenubox" style="margin-top: 10px">
      <div
        v-if="getAllMenuCodes.includes('wJpDFH9V')"
        :class="tab === 'pendingReview' ? 'datamenuitem died' : 'datamenuitem'"
        @click="changeTab('pendingReview')"
      >
        待审核采收单
      </div>
      <div
        v-if="getAllMenuCodes.includes('iIBSjSQ1')"
        :class="tab === 'pendingPackage' ? 'datamenuitem died' : 'datamenuitem'"
        @click="changeTab('pendingPackage')"
        style="margin-left: 8px"
      >
        采收包装单
      </div>
      <div
        v-if="getAllMenuCodes.includes('rfm5j70E')"
        :class="tab === 'packageList' ? 'datamenuitem died' : 'datamenuitem'"
        @click="changeTab('packageList')"
        style="margin-left: 8px"
      >
        包装单
      </div>
    </div>
    <div class="databox">
      <!-- 无tab权限时显示空数据 -->
      <div v-if="!hasTabPermission" class="no-permission">
        <div style="text-align: center; color: #fff; padding: 50px">
          <p>暂无权限查看相关数据</p>
          <el-button
            type="info"
            style="margin-top: 15px"
            size="small"
            @click="goBack"
            >返回</el-button
          >
        </div>
      </div>
      <template v-else>
        <div class="top-filters" style="width: 100%; margin-bottom: 12px">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              width: 100%;
            "
          >
            <div style="display: flex; align-items: center; gap: 12px">
              <div class="time-label">所属大棚：</div>
              <el-select
                v-model="greenhouseId"
                placeholder="请选择"
                size="small"
                style="width: 140px"
                clearable
              >
                <el-option
                  v-for="item in greenhouseOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>

              <!-- 在 待审核 显示状态与采收负责人 -->
              <template v-if="tab === 'pendingReview'">
                <div class="time-label">采收负责人：</div>
                <el-select
                  v-model="harvestManager"
                  placeholder="请选择"
                  size="small"
                  style="width: 140px"
                  clearable
                >
                  <el-option
                    v-for="opt in harvestManagerOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
              </template>

              <!-- 在 待包装 显示包装状态与采收负责人 -->
              <template v-if="tab === 'pendingPackage'">
                <div class="time-label">状态：</div>
                <el-select
                  v-model="packStatus"
                  placeholder="全部"
                  size="small"
                  style="width: 120px"
                  clearable
                >
                  <el-option
                    v-for="opt in packStatusOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>

                <div class="time-label">采收负责人：</div>
                <el-select
                  v-model="harvestManager"
                  placeholder="请选择"
                  size="small"
                  style="width: 140px"
                  clearable
                >
                  <el-option
                    v-for="opt in harvestManagerOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
              </template>

              <!-- 在 包装单 显示分级规格与品控员（用于 packing/dtl-page 搜索） -->
              <template v-if="tab === 'packageList'">
                <div class="time-label">分级规格：</div>
                <el-select
                  v-model="spec"
                  placeholder="请选择"
                  size="small"
                  style="width: 120px"
                  clearable
                >
                  <el-option
                    v-for="opt in specOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
              </template>

              <div class="time-label">采收日期：</div>
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                size="small"
                value-format="yyyy-MM-dd"
              />

              <el-button type="primary" size="small" @click="onQuery"
                >查询</el-button
              >
              <el-button size="small" @click="onReset">刷新/重置</el-button>
              <!-- 采收包装单和包装单tab显示导出按钮 -->
              <template
                v-if="tab === 'pendingPackage' || tab === 'packageList'"
              >
                <el-button
                  type="success"
                  size="small"
                  icon="el-icon-download"
                  @click="handleExport"
                  >导出</el-button
                >
              </template>
            </div>
          </div>
        </div>

        <div class="table-wrap" style="width: 100%">
          <!-- 待审核表格 -->
          <el-table
            v-if="tab === 'pendingReview'"
            :data="pendingReviewList"
            border
            height="65vh"
            style="width: 100%; background: #fff"
          >
            <el-table-column
              prop="batchNumber"
              label="采收批次号"
              width="160"
            />
            <el-table-column prop="harvestDate" label="采收日期">
              <template slot-scope="{ row }">{{
                formatDate(row.harvestDate)
              }}</template>
            </el-table-column>
            <el-table-column prop="plantingBase" label="基地名称" />
            <el-table-column prop="greenhouseName" label="大棚编号" />
            <el-table-column prop="varietyName" label="产品名称" />
            <el-table-column prop="sumWeight" label="采收草莓总量 (kg)" />

            <el-table-column prop="harvestManager" label="采收负责人" />
            <el-table-column prop="updateTime" label="更新时间" />
            <el-table-column prop="status" label="状态">
              <template slot-scope="{ row }">{{
                mapStatus(row.status)
              }}</template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="viewItem(row)"
                  >查看</el-button
                >
                <el-button
                  v-if="getAllMenuCodes.includes('MqNaof02')"
                  type="text"
                  size="small"
                  @click="reviewItem(row)"
                >
                  审核
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 待包装表格 -->
          <el-table
            v-else-if="tab === 'pendingPackage'"
            :data="pendingPackageList"
            border
            key="pendingPackage"
            height="65vh"
            style="width: 100%; background: #fff"
          >
            <el-table-column prop="batchNumber" label="采收批次号" width="160">
              <template slot-scope="{ row }">{{
                row.batchNumber ? row.batchNumber : "-"
              }}</template>
            </el-table-column>
            <el-table-column prop="harvestDate" label="采收日期">
            </el-table-column>
            <el-table-column prop="plantingBase" label="基地名称" />
            <el-table-column prop="greenhouseName" label="大棚编号" />
            <el-table-column prop="varietyName" label="产品名称" />
            <el-table-column
              prop="sumPackWeight"
              label="包装合计重量 (kg)"
              width="160"
            />
            <el-table-column prop="sumPackBoxes" label="总包装数量 (盒)" />
            <el-table-column prop="lossWeight" label="坏果量 (kg)" />
            <el-table-column prop="reviewer" label="品控员" />
            <el-table-column prop="updateTime" label="更新时间" />
            <el-table-column prop="packStatus" label="状态">
              <template slot-scope="{ row }">{{
                mapPackStatus(row.packStatus)
              }}</template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="viewItem(row)"
                  >查看</el-button
                >
                <el-button
                  v-if="
                    row.packStatus !== 'PACKAGED' &&
                    getAllMenuCodes.includes('xvBUqPoL')
                  "
                  type="text"
                  size="small"
                  @click="packageItem(row)"
                >
                  包装
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 包装单表格 -->
          <el-table
            v-else-if="tab === 'packageList'"
            :data="packageList"
            border
            key="packageList"
            height="65vh"
            style="width: 100%; background: #fff"
          >
            <el-table-column prop="batchNumber" label="包装批次号" width="160">
              <template slot-scope="{ row }">{{
                row.batchNumber ? row.batchNumber : "-"
              }}</template>
            </el-table-column>
            <el-table-column prop="harvestBatchNumber" label="采收批次号">
              <template slot-scope="{ row }">{{
                row.harvestBatchNumber ? row.harvestBatchNumber : "-"
              }}</template>
            </el-table-column>
            <el-table-column prop="harvestDate" label="采收日期">
            </el-table-column>
            <el-table-column prop="plantingBase" label="基地名称" />
            <el-table-column prop="greenhouseName" label="大棚编号" />
            <el-table-column prop="varietyName" label="产品名称" />
            <el-table-column
              prop="specSize"
              label="分级规格"
              :formatter="formatSpecCell"
            />
            <el-table-column prop="basicStorageName" label="仓储位置"
              ><template slot-scope="{ row }">{{
                row.basicStorageName ? row.basicStorageName : "-"
              }}</template></el-table-column
            >
            <el-table-column prop="weight" label="重量 (kg)" />
            <el-table-column prop="boxes" label="包装数量 (盒)" />
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="viewItem(row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <ReviewDialog
            :visible.sync="reviewDialogVisible"
            :mode="dialogMode"
            :current-record="currentRecord"
            :user-info="userInfo"
            @update-reviewer="onUpdateReviewer"
            @approve="onApprove"
            @reject="onReject"
            :showLossWeight="tab !== 'packageList'"
            @close="closeReviewDialog"
          />
          <PackingDialog
            :visible.sync="packingDialogVisible"
            :current-record="packingRecord"
            :user-info="userInfo"
            @saved="onPackingSaved"
            @close="closePackingDialog"
          />

          <div
            class="pagination-wrapper"
            style="margin-top: 12px; background: transparent"
          >
            <div
              style="
                display: flex;
                align-items: center;
                gap: 12px;
                width: 100%;
                justify-content: center;
              "
            >
              <el-pagination
                :current-page="page.page"
                :page-size="page.pageSize"
                :total="page.totalCount"
                layout="total, sizes, prev, pager, next, jumper"
                @current-change="onPageChange"
                @size-change="onSizeChange"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Header from "../../Header.vue";
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import dayjs from "dayjs";

export default {
  name: "HarvestPartition",
  components: {
    Header,
    ReviewDialog: () => import("./ReviewDialog.vue"),
    PackingDialog: () => import("./PackingDialog.vue"),
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes", "userInfo"]),
    // 判断是否有tab权限
    hasTabPermission() {
      return (
        this.getAllMenuCodes.includes("wJpDFH9V") ||
        this.getAllMenuCodes.includes("iIBSjSQ1") ||
        this.getAllMenuCodes.includes("rfm5j70E")
      );
    },
    // 显示的品控员名称：优先显示最近一条审核记录的 reviewer，否则显示记录上的 reviewer 字段，再 fallback 到当前登录账号
    displayedReviewerName() {
      try {
        const logs = this.currentRecord && this.currentRecord.reviewLogList;
        if (Array.isArray(logs) && logs.length > 0) {
          // 取最后一条为最近一次（如果后端返回有序则更好），否则取创建时间最大的
          const last = logs[logs.length - 1];
          return last.reviewer || last.reviewerName || "";
        }
      } catch (e) {
        // ignore
      }
      if (
        this.currentRecord &&
        (this.currentRecord.reviewer || this.currentRecord.reviewerName)
      ) {
        return this.currentRecord.reviewerName || this.currentRecord.reviewer;
      }
      // fallback to Vuex userInfo
      return (
        (this.userInfo && (this.userInfo.nickName || this.userInfo.username)) ||
        ""
      );
    },
    // 当前tab对应的数据源
    currentList() {
      switch (this.tab) {
        case "pendingReview":
          return this.pendingReviewList;
        case "pendingPackage":
          return this.pendingPackageList;
        case "packageList":
          return this.packageList;
        default:
          return [];
      }
    },
  },
  data() {
    return {
      tab: "pendingReview",
      // filters
      dateRange: [],
      greenhouseId: "",
      greenhouseOptions: [],
      spec: "",
      specOptions: [
        { label: "大果(特级果)", value: "LARGE" },
        { label: "中果(优质果)", value: "MEDIUM" },
        { label: "小果(精品果)", value: "SMALL" },
        { label: "次果", value: "INFERIOR" },
        { label: "宝宝果", value: "BABY" },
        { label: "蓝装草莓", value: "BASKET" },
      ],
      reviewer: "",
      // 待审核专用筛选
      orderStatus: "",
      orderStatusOptions: [
        { label: "草稿", value: "DRAFT" },
        { label: "待审核", value: "PENDING" },
        { label: "已审核", value: "REVIEWED" },
        { label: "已退回", value: "REJECTED" },
      ],
      // 待包装专用筛选
      packStatus: "",
      packStatusOptions: [
        { label: "草稿", value: "DRAFT" },
        { label: "待包装", value: "PENDING" },
        { label: "已包装", value: "PACKAGED" },
      ],
      harvestManager: "",
      harvestManagerOptions: [],

      // table & pagination
      page: {
        page: 1,
        pageSize: 10,
        totalCount: 0,
      },
      // 各tab独立的数据源
      pendingReviewList: [],
      pendingPackageList: [],
      packageList: [],
      selectedRows: [],
      // 审核弹窗状态 & 表单
      reviewDialogVisible: false,
      // 包装弹窗状态
      packingDialogVisible: false,
      packingRecord: null,
      currentRecord: null,
      dialogMode: "",
      reviewForm: {
        id: null,
        batchNumber: "",
        harvestDate: null,
        reviewerId: null,
        reviewerName: "",
        deliverToPackaging: false,
        packagingDate: null,
        reviewComment: "",
      },
    };
  },
  created() {
    this.getGreenhouseOptions();
    this.getHarvestManagerOptions();
    this.fetchPage();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    changeTab(tab) {
      this.tab = tab;
      // 清空可能影响显示的状态
      this.pendingReviewList = [];
      this.pendingPackageList = [];
      this.packageList = [];
      this.selectedRows = [];
      // 重置筛选条件
      this.dateRange = [];
      this.greenhouseId = "";
      this.spec = "";
      this.reviewer = "";
      this.orderStatus = "";
      this.packStatus = "";
      this.harvestManager = "";
      // reset page and fetch for the selected tab
      this.page.page = 1;
      this.page.totalCount = 0;
      this.fetchPage();
    },
    formatDate(v) {
      if (!v) return "";
      try {
        return dayjs(v).format("YYYY/MM/DD");
      } catch (e) {
        return v;
      }
    },
    mapStatus(s) {
      const map = {
        DRAFT: "草稿",
        PENDING: "待审核",
        REVIEWED: "已审核",
        REJECTED: "已退回",
      };
      return map[s] || s || "";
    },
    mapSpec(s) {
      const map = {
        LARGE: "大果(特级果)",
        MEDIUM: "中果(优质果)",
        SMALL: "小果(精品果)",
        INFERIOR: "次果",
        BABY: "宝宝果",
        BASKET: "蓝装草莓",
      };
      return map[s] || s || "";
    },
    // formatter for table column to avoid scoped-slot issues
    formatSpecCell(row) {
      try {
        return this.mapSpec(row && row.specSize);
      } catch (e) {
        return "";
      }
    },
    mapPackStatus(s) {
      const map = {
        DRAFT: "草稿",
        PENDING: "待包装",
        PACKAGED: "已包装",
      };
      return map[s] || s || "";
    },
    buildParams(page) {
      const params = {
        page: page.page,
        pageSize: page.pageSize,
      };
      if (this.greenhouseId) params.greenhouseId = this.greenhouseId;
      // 默认：非包装单使用旧参数名，包装单使用 packing 接口的参数名
      if (this.tab === "packageList") {
        if (this.spec) params.specSize = this.spec;
        if (this.reviewer) params.reviewerId = this.reviewer;
      } else {
        if (this.spec) params.spec = this.spec;
        if (this.reviewer) params.reviewer = this.reviewer;
      }
      // 若为 待审核 或 待包装，传递状态与采收负责人用于后端筛选
      if (this.tab === "pendingReview") {
        // 待审核采收单传PENDING
        params.status = "PENDING";
        if (this.harvestManager) params.harvestManagerId = this.harvestManager;
      } else if (this.tab === "pendingPackage") {
        // 采收包装单传status=REVIEWED
        params.status = "REVIEWED";
        if (this.packStatus) params.packStatus = this.packStatus;
        if (this.harvestManager) params.harvestManagerId = this.harvestManager;
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.harvestDateStart = this.dateRange[0];
        params.harvestDateEnd = this.dateRange[1];
      }
      return params;
    },
    /**
     * 构建导出参数 - 不带分页参数，导出全部筛选数据
     */
    buildExportParams() {
      const params = {};
      if (this.greenhouseId) params.greenhouseId = this.greenhouseId;

      // 包装单tab使用 packing 接口的参数名
      if (this.tab === "packageList") {
        if (this.spec) params.specSize = this.spec;
        if (this.reviewer) params.reviewerId = this.reviewer;
      } else {
        // 待包装tab
        if (this.spec) params.spec = this.spec;
        if (this.reviewer) params.reviewer = this.reviewer;
      }

      // 待包装tab传递状态与采收负责人
      if (this.tab === "pendingPackage") {
        params.status = "REVIEWED";
        if (this.packStatus) params.packStatus = this.packStatus;
        if (this.harvestManager) params.harvestManagerId = this.harvestManager;
      }

      // 包装单tab没有其他特殊筛选

      if (this.dateRange && this.dateRange.length === 2) {
        params.harvestDateStart = this.dateRange[0];
        params.harvestDateEnd = this.dateRange[1];
      }
      return params;
    },
    async fetchPage() {
      try {
        const params = this.buildParams(this.page);
        // 使用与项目风格相同的 axios/baseUrl
        const url =
          this.tab === "packageList"
            ? baseUrl + "/api/digital-farming/harvest/packing/dtl-page"
            : baseUrl + "/api/digital-farming/harvest/order-page";
        const res = await axios.post(url, params);
        if (res && res.code === 200 && res.data) {
          const d = res.data;
          this.page.totalCount = parseInt(d.totalCount) || 0;
          this.page.page = parseInt(d.page) || this.page.page;
          this.page.pageSize = parseInt(d.pageSize) || this.page.pageSize;
          const listData = Array.isArray(d.list) ? d.list : [];

          // 根据当前tab更新对应的数据源
          switch (this.tab) {
            case "pendingReview":
              this.pendingReviewList = listData;
              break;
            case "pendingPackage":
              this.pendingPackageList = listData;
              break;
            case "packageList":
              this.packageList = listData;
              break;
          }
        } else {
          // 如果后端没有该接口，保持本地空数据避免报错
          const fallbackData = Array.isArray(res && res.data && res.data.list)
            ? res.data.list
            : [];

          // 根据当前tab更新对应的数据源
          switch (this.tab) {
            case "pendingReview":
              this.pendingReviewList = fallbackData;
              break;
            case "pendingPackage":
              this.pendingPackageList = fallbackData;
              break;
            case "packageList":
              this.packageList = fallbackData;
              break;
          }
        }
      } catch (err) {
        console.error("fetchPage error:", err);
      }
    },
    onQuery() {
      this.page.page = 1;
      this.fetchPage();
    },
    onReset() {
      this.dateRange = [];
      this.greenhouseId = "";
      this.spec = "";
      this.reviewer = "";
      this.orderStatus = "";
      this.packStatus = "";
      this.harvestManager = "";
      this.page.page = 1;
      // 清空当前tab的数据
      this.clearCurrentTabData();
      this.fetchPage();
    },
    onPageChange(page) {
      this.page.page = page;
      this.fetchPage();
    },
    onSizeChange(size) {
      this.page.pageSize = size;
      this.page.page = 1;
      this.fetchPage();
    },
    onSelectionChange(rows) {
      this.selectedRows = Array.isArray(rows) ? rows : [];
    },
    viewItem(row) {
      // 打开查看弹窗：与审核弹窗显示内容一致，但为只读模式
      this.reviewForm = {
        id: null,
        batchNumber: "",
        harvestDate: null,
        reviewerId: null,
        reviewerName: "",
        deliverToPackaging: false,
        packagingDate: null,
        reviewComment: "",
      };
      this.dialogMode = "view";
      // fetch details - 先获取数据再打开弹窗
      const url =
        this.tab === "packageList"
          ? `/api/digital-farming/harvest/packing/dtl-detail/${row.id}`
          : `/api/digital-farming/harvest/order-detail/${row.id}`;
      axios
        .post(baseUrl + url)
        .then((res) => {
          const d = res && (res.data || res);
          this.currentRecord = d || row;
          this.reviewDialogVisible = true;
        })
        .catch(() => {
          this.currentRecord = row;
          this.reviewDialogVisible = true;
        });
    },
    async reviewItem(row) {
      // 打开审核弹窗，优先从后端查询详情并回显所有只读字段/包装明细/审核记录
      this.reviewDialogVisible = true;
      // 初始化表单
      this.reviewForm = {
        id: null,
        batchNumber: "",
        harvestDate: null,
        reviewerId: null,
        reviewerName: "",
        deliverToPackaging: false,
        packagingDate: null,
        reviewComment: "",
      };

      try {
        const res = await axios.post(
          baseUrl + `/api/digital-farming/harvest/order-detail/${row.id}`
        );
        const d = res && (res.data || res);
        if (d) {
          // 后端返回对象结构直接放入 currentRecord
          this.currentRecord = d;
          // 可编辑回显项
          this.reviewForm.id = d.id;
          this.reviewForm.batchNumber = d.batchNumber || "";
          this.reviewForm.harvestDate = d.harvestDate || null;
          this.reviewForm.reviewerId = d.reviewerId || null;
          this.reviewForm.reviewerName = d.reviewer || "";
          this.reviewForm.deliverToPackaging = !!d.packaged;
          this.reviewForm.packagingDate = d.deliveryDate || null;
          this.reviewForm.reviewComment = "";
        } else {
          // 兜底使用表格行数据
          this.currentRecord = row;
          this.reviewForm.id = row.id;
          this.reviewForm.batchNumber = row.batchNumber || "";
          this.reviewForm.harvestDate = row.harvestDate || null;
          this.reviewForm.reviewerId = row.reviewerId || null;
          this.reviewForm.reviewerName = row.reviewerName || row.reviewer || "";
          this.reviewForm.deliverToPackaging =
            !!row.packaged || !!row.deliverToPackaging;
          this.reviewForm.packagingDate =
            row.deliveryDate || row.packagingDate || null;
          this.reviewForm.reviewComment = row.reviewComment || "";
        }
      } catch (err) {
        console.error("获取采收详情失败:", err);
        // 兜底回显表格行数据
        this.currentRecord = row;
        this.reviewForm.id = row.id;
        this.reviewForm.batchNumber = row.batchNumber || "";
        this.reviewForm.harvestDate = row.harvestDate || null;
        this.reviewForm.reviewerId = row.reviewerId || null;
        this.reviewForm.reviewerName = row.reviewerName || row.reviewer || "";
        this.reviewForm.deliverToPackaging =
          !!row.packaged || !!row.deliverToPackaging;
        this.reviewForm.packagingDate =
          row.deliveryDate || row.packagingDate || null;
        this.reviewForm.reviewComment = row.reviewComment || "";
      }
      // set dialog mode
      this.dialogMode = "review";
    },
    async packageItem(row) {
      // 打开包装弹窗：优先从后端获取详情回显
      this.packingRecord = null;
      this.packingDialogVisible = true;
      try {
        const res = await axios.post(
          baseUrl + `/api/digital-farming/harvest/order-detail/${row.id}`
        );
        const d = res && (res.data || res);
        this.packingRecord = d || row;
      } catch (err) {
        console.error("获取采收详情失败:", err);
        this.packingRecord = row;
      }
    },
    onPackingSaved(payload) {
      // payload may contain { isDraft }
      this.packingDialogVisible = false;
      this.packingRecord = null;
      this.$message &&
        this.$message.success &&
        this.$message.success(
          payload && payload.isDraft ? "已保存草稿" : "包装已提交"
        );
      // 刷新页数据
      this.fetchPage();
    },
    closePackingDialog() {
      this.packingDialogVisible = false;
      this.packingRecord = null;
    },
    doPartition(row) {
      // 保留旧动作兼容
      this.$router
        .push({ path: `/techFarm/harvest/operate-partition/${row.id}` })
        .catch(() => {});
    },
    async getHarvestManagerOptions() {
      try {
        const res = await axios.post(baseUrl + "/api/system/users");
        if (res.code === 200) {
          const users = res.data || [];
          console.log("获取的用户", users);
          this.harvestManagerOptions = users
            .filter(
              (user) =>
                user.roleCodes &&
                user.roleCodes.split(",").includes("harvesting_supervisor")
            )
            .map((user) => ({
              label: user.nickName,
              value: user.id,
            }));
        }
      } catch (error) {
        console.error("获取用户列表失败:", error);
      }
    },
    closeReviewDialog() {
      // 重置表单（保留 currentRecord 直到弹窗关闭）
      this.reviewDialogVisible = false;
      // reset form values but keep currentRecord for safety
      this.$nextTick(() => {
        this.reviewForm = {
          id: null,
          batchNumber: "",
          harvestDate: null,
          reviewerId: null,
          reviewerName: "",
          deliverToPackaging: false,
          packagingDate: null,
          reviewComment: "",
        };
        this.currentRecord = null;
      });
    },

    async onUpdateReviewer() {
      // 点击"更新"按钮：直接将当前登录账号写入为品控员（客户端与后端占位接口）
      if (!this.reviewForm.id) {
        this.$message &&
          this.$message.error &&
          this.$message.error("无效的记录");
        return;
      }
      try {
        // 使用 Vuex userInfo 更新 reviewer 字段
        const newReviewerId = this.userInfo && this.userInfo.userId;
        console.log("reviewerId", this.userInfo);

        const newReviewerName = this.userInfo.nickName;

        // 本地回显并更新列表中的该条数据
        this.reviewForm.reviewerId = newReviewerId;
        this.reviewForm.reviewerName = newReviewerName;
        this.updateLocalRecordReviewer(newReviewerId, newReviewerName);
        if (this.currentRecord) {
          this.currentRecord = {
            ...this.currentRecord,
            reviewer: newReviewerName,
            reviewerId: newReviewerId,
            reviewerName: newReviewerName,
            reviewLogList: [], // 清空 reviewLogList，强制 displayedReviewer 检查 reviewer 字段
          };
        }

        this.$message &&
          this.$message.success &&
          this.$message.success("品控员已更新为当前账号");
      } catch (err) {
        console.error("更新品控员失败:", err);
        this.$message && this.$message.error && this.$message.error("更新失败");
      }
    },

    // 审核通过
    async onApprove() {
      // payload may be passed from dialog or use reviewForm
      const usingPayload = arguments && arguments.length ? arguments[0] : null;
      if (
        usingPayload &&
        usingPayload.deliverToPackaging &&
        !usingPayload.packagingDate
      ) {
        this.$message &&
          this.$message.error &&
          this.$message.error("请选择交付包装日期");
        return;
      }
      if (!usingPayload && !this.validatePackagingDate()) return;
      try {
        const reviewerId = (this.userInfo && this.userInfo.userId) || null;
        const reviewerName =
          (this.userInfo &&
            (this.userInfo.nickName || this.userInfo.username)) ||
          "";
        const payload = {
          id: usingPayload ? usingPayload.id : this.reviewForm.id,
          reviewStatus: 200,
          reviewerId: reviewerId,
          reviewer: reviewerName,
          packaged: usingPayload
            ? !!usingPayload.deliverToPackaging
            : !!this.reviewForm.deliverToPackaging,
          deliveryDate: usingPayload
            ? usingPayload.packagingDate || undefined
            : this.reviewForm.packagingDate || undefined,
          reviewMsg: usingPayload
            ? usingPayload.reviewComment || undefined
            : this.reviewForm.reviewComment || undefined,
        };

        await axios.post(
          baseUrl + "/api/digital-farming/harvest/order-review",
          payload
        );

        // 更新本地并刷新列表（使用后端为准，故优先 fetchPage）
        this.$message &&
          this.$message.success &&
          this.$message.success("已审核通过");
        this.closeReviewDialog();
        // 重新请求页面数据以保证列表与后端一致
        this.fetchPage();
      } catch (err) {
        console.error("审核通过失败:", err);
        this.$message && this.$message.error && this.$message.error("审核失败");
      }
    },

    // 退回
    async onReject() {
      if (!this.reviewForm.id && !(arguments && arguments.length)) {
        this.$message &&
          this.$message.error &&
          this.$message.error("无效的记录");
        return;
      }
      try {
        const usingPayload =
          arguments && arguments.length ? arguments[0] : null;
        const reviewerId = (this.userInfo && this.userInfo.userId) || null;
        const reviewerName =
          (this.userInfo &&
            (this.userInfo.nickName || this.userInfo.username)) ||
          "";
        const payload = {
          id: usingPayload ? usingPayload.id : this.reviewForm.id,
          reviewStatus: 300,
          reviewerId: reviewerId,
          reviewer: reviewerName,
          packaged: usingPayload
            ? !!usingPayload.deliverToPackaging
            : !!this.reviewForm.deliverToPackaging,
          deliveryDate: usingPayload
            ? usingPayload.packagingDate || undefined
            : this.reviewForm.packagingDate || undefined,
          reviewMsg: usingPayload
            ? usingPayload.reviewComment || undefined
            : this.reviewForm.reviewComment || undefined,
        };

        await axios.post(
          baseUrl + "/api/digital-farming/harvest/order-review",
          payload
        );

        this.$message &&
          this.$message.success &&
          this.$message.success("已退回");
        this.closeReviewDialog();
        this.fetchPage();
      } catch (err) {
        console.error("退回失败:", err);
        this.$message && this.$message.error && this.$message.error("退回失败");
      }
    },

    validatePackagingDate() {
      if (
        this.reviewForm.deliverToPackaging === true &&
        !this.reviewForm.packagingDate
      ) {
        this.$message &&
          this.$message.error &&
          this.$message.error("请选择交付包装日期");
        return false;
      }
      return true;
    },

    clearCurrentTabData() {
      // 清空当前tab对应的数据源
      switch (this.tab) {
        case "pendingReview":
          this.pendingReviewList = [];
          break;
        case "pendingPackage":
          this.pendingPackageList = [];
          break;
        case "packageList":
          this.packageList = [];
          break;
      }
    },

    updateLocalRecordReviewer(reviewerId, reviewerName) {
      // 将更新同步到当前列表（对应tab的数据源）中的对应项，保证界面反显
      const currentList = this.currentList;
      try {
        const idx = currentList.findIndex((it) => it.id === this.reviewForm.id);
        if (idx !== -1) {
          this.$set(currentList[idx], "reviewer", reviewerName);
          this.$set(currentList[idx], "reviewerId", reviewerId);
          this.$set(currentList[idx], "reviewerName", reviewerName);
        }
      } catch (e) {
        // 低版本 Vue 可能没有 $set，做兼容替换
        for (let i = 0; i < currentList.length; i++) {
          if (currentList[i].id === this.reviewForm.id) {
            currentList[i].reviewer = reviewerName;
            currentList[i].reviewerId = reviewerId;
            currentList[i].reviewerName = reviewerName;
            break;
          }
        }
      }
    },
    async getGreenhouseOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/basic/greenhouse/selection"
        );
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.greenhouseOptions = res.data.map((it) => ({
            label: it.serialNumber || it.name || it.id,
            value: it.id,
          }));
        }
      } catch (err) {
        console.error("getGreenhouseOptions error:", err);
      }
    },

    /**
     * 导出采收包装单/包装单数据
     * 使用流文件下载方式
     * 采收包装单：/api/digital-farming/harvest/order-export
     * 包装单：/api/digital-farming/harvest/packing/dtl-export
     */
    async handleExport() {
      try {
        const exportParams = this.buildExportParams();

        // 根据tab选择不同的导出接口
        const exportUrl =
          this.tab === "pendingPackage"
            ? baseUrl + "/api/digital-farming/harvest/order-export"
            : baseUrl + "/api/digital-farming/harvest/packing/dtl-export";

        const response = await axios.post(exportUrl, exportParams, {
          responseType: "blob",
        });

        // 处理文件流下载
        // 如果响应已经是Blob，直接使用；否则创建新的Blob
        let blob;
        if (response instanceof Blob) {
          blob = response;
        } else if (response.data instanceof Blob) {
          blob = response.data;
        } else {
          blob = new Blob([response.data || response], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
        }

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.style.display = "none";

        // 根据当前tab生成文件名
        const tabName = this.tab === "pendingPackage" ? "采收包装单" : "包装单";
        const fileName = `${tabName}_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`;
        link.setAttribute("download", fileName);

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        this.$message &&
          this.$message.success &&
          this.$message.success("导出成功");
      } catch (err) {
        console.error("导出失败:", err);
        this.$message && this.$message.error && this.$message.error("导出失败");
      }
    },
  },
};
</script>

<style scoped lang="less">
.datamenubox {
  margin: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;

  .datamenuitem {
    padding: 10px 20px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    background-image: url("../../../assets/img/data/btn.png");
    background-size: 100% 100%;
  }

  .died {
    background-image: url("../../../assets/img/data/btned.png");
  }
}

.databox {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 160px);
  background: rgba(0, 11, 47, 0.5);
  box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
  border-radius: 0px 0px 0px 0px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.top-filters {
  .time-label {
    margin-left: 0;
    color: #fff;
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
}

.no-permission {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #fff;
  font-size: 16px;
}
</style>
